import React, { useState } from "react";
import { Card, Form } from "react-bootstrap";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

// Component for inference steps widget

// Inference steps refer to the number of times that noise is removed
// from an image

let MAX_STEPS = 50;

export default function InferenceSteps(props) {
  return (
    <div>
      <span>
        Steps
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id="tooltip-disabled">
              Choose the number of steps or improvements to the image
            </Tooltip>
          }
        >
          <span style={{ marginLeft: "0.5vw" }}>ⓘ</span>
        </OverlayTrigger>
      </span>
      {/* Update steps if either text box or slider input is changed */}
      <Form.Control
        id="Steps"
        value={props.steps}
        onChange={(e) => props.setSteps(parseInt(e.target.value))}
      ></Form.Control>
      <Form.Range min={1} max={20} value={props.steps} onChange={(e) => props.setSteps(parseInt(e.target.value))} />
    </div>
  );
}
